import { render } from "./arrayOfObjects.vue?vue&type=template&id=0226c358&scoped=true"
import script from "./arrayOfObjects.vue?vue&type=script&lang=js"
export * from "./arrayOfObjects.vue?vue&type=script&lang=js"

import "./arrayOfObjects.vue?vue&type=style&index=0&id=0226c358&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-10\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0226c358"]])

export default __exports__